<template>
  <div class="filter-panel ad-d-flex ad-d-flex-between">
    <div class="ad-d-flex ad-d-start filter-panel-left-part">
      <!--所有筛选-->
      <div class="all-filters-wrapper ad-m-b-xs"
          v-clickoutside="onClickOutsideAllFilters">
        <byted-button class="btn-filter-all"
          v-if="!isRf"
          id="all-filter-btn"
          size="small"
          type="primary"
          plain
          @click="onClickAllFiltersBtn">
          <div class="ad-d-flex ad-d-flex-center">
            <byted-icon name="filter"></byted-icon>
            <div class="ad-m-l-xs ad-m-r-xs">{{ $bp_t('所有筛选', 'bp.promotion_all_screening') }}</div>
            <byted-icon name="angle-down" :class="`${showSubFilterPanel?'open_':'close_'}`"></byted-icon>
          </div>
        </byted-button>
        <beginner-guide-popover
          v-else
          transfer
          guide-key="promote-filter-panel-guide"
          placement="right-start"
          width="264px"
          :primary-btn="{
            text: $bp_t('我知道了', 'common.i_got_it'),
            isClose: true
          }"
        >
          <template slot="title">
            <div class="guide-title-box">
              <byted-icon-tips class="guide-title-icon" theme="outline" size="16" fill="#fff"/>
              新增筛选项：购买类型
            </div>
          </template>
          <template slot="content">
            <div class="guide-pop-text">
              支持筛选购买类型为「合约」或「竞价」的计划。当前默认为「竞价」，如需查看合约类型计划，请先筛选。
            </div>
          </template>
          <byted-button class="btn-filter-all"
            slot="reference"
            id="all-filter-btn"
            size="small"
            type="primary"
            plain
            @click="onClickAllFiltersBtn">
            <div class="ad-d-flex ad-d-flex-center">
              <byted-icon name="filter"></byted-icon>
              <div class="ad-m-l-xs ad-m-r-xs">{{ $bp_t('所有筛选', 'bp.promotion_all_screening') }}</div>
              <byted-icon name="angle-down" :class="`${showSubFilterPanel?'open_':'close_'}`"></byted-icon>
            </div>
          </byted-button>
        </beginner-guide-popover>

        <!--所有筛选面板-->
        <div class="filter-panel-sub-panel"
             v-show="showSubFilterPanel">
          <ul class="sub-filters-nav-wrapper">
            <li class="filter-nav-item"
                :class="{active: activeFilterNavID === nav.id}"
                v-for="(nav, index) in filtersNav"
                :key="index">
              <a @click="onClickFilterNavItem(nav.id)">{{nav.label}}</a>
            </li>
            <byted-button class="close-sub-filters-btn"
                          size="small"
                          type="primary"
                          plain
                          @click="showSubFilterPanel = false">{{ $bp_t('收起', 'common.retract') }}
            </byted-button>
          </ul>

          <div class="sub-filters-content-wrapper" ref="subFiltersContentWrapper">
            <!-- 为避免模板视图层逻辑过于复杂，此处省略了一层 filters 的循环-->
            <div class="sub-filters-group">
              <h4 class="sub-filters-group-title"
                  id="campaign-anchor">{{ $bp_t('组', 'common.group') }}</h4>
              <div class="sub-filters-group-wrapper"
                   v-for="(filtersGroup, key) in filters.campaign"
                   :key="key">
                <div class="sub-filters"
                     :key="index"
                     v-for="(filter, index) in filtersGroup">
                  <h5 class="sub-filter-name">{{AllFiltersConfig[filter.key].name}}</h5>
                  <automate-rule-input 
                    v-if="filter.automateRule"
                    @valueChanged="(value) => autoRuleInputChange(filter.key, 'campaign', value)"
                    :rangeTypeList="filter.rangeTypeList" 
                    :value="filter.value"
                  />
                  <template v-else>
                    <byted-cascader
                            transfer
                            v-if="AllFiltersConfig[filter.key].type !== rangeFilterType"
                            size="sm"
                            :options="AllFiltersConfig[filter.key].options"
                            v-model="AllFiltersConfig[filter.key].selected"
                            :placeholder="$bp_t('请选择', 'common.please_choose')"
                            :multiple="AllFiltersConfig[filter.key].multiple"
                            collapse-tags
                            @change="handleFilterChange(AllFiltersConfig[filter.key])"></byted-cascader>
                    <!--<range-select v-if="filter.type === rangeFilterType"-->
                                  <!--button-type="primary"-->
                                  <!--@confirm="handleFilterChange(filter)"-->
                                  <!--v-model="AllFiltersConfig[filter.key].selected"></range-select>-->
                  </template>
                </div>
              </div>
            </div>

            <div class="sub-filters-group" id="sub-filters-group-id">
              <h4 class="sub-filters-group-title"
                  id="ad-anchor">{{ $bp_t('计划', 'common.plan') }}</h4>
              <div class="sub-filters-group-wrapper"
                   v-for="(filtersGroup, key) in filters.ad"
                   :key="key">
                <div class="sub-filters"
                     v-if="!filter.displayOnly"
                     :key="index"
                     v-for="(filter, index) in filtersGroup">
                  <h5 class="sub-filter-name">{{AllFiltersConfig[filter.key].name}}</h5>
                  <automate-rule-input 
                    v-if="filter.automateRule"
                    @valueChanged="(value) => autoRuleInputChange(filter.key, 'ad', value)"
                    :rangeTypeList="filter.rangeTypeList" 
                    :value="filter.value"
                  />
                  <template v-else>
                    <byted-cascader
                            transfer
                            v-if="AllFiltersConfig[filter.key].type !== rangeFilterType"
                            size="sm"
                            :options="AllFiltersConfig[filter.key].options"
                            v-model="AllFiltersConfig[filter.key].selected"
                            :placeholder="$bp_t('请选择', 'common.please_choose')"
                            :multiple="AllFiltersConfig[filter.key].multiple"
                            collapse-tags
                            @change="handleFilterChange(AllFiltersConfig[filter.key])"></byted-cascader>
                    <!--<range-select v-if="filter.type === rangeFilterType"-->
                                  <!--button-type="primary"-->
                                  <!--@confirm="handleFilterChange(filter)"-->
                                  <!--v-model="AllFiltersConfig[filter.key].selected"></range-select>-->
                  </template>
                </div>
              </div>
            </div>

            <div class="sub-filters-group">
              <h4 class="sub-filters-group-title"
                  id="creative-anchor">{{ $bp_t('创意', 'common.originality') }}</h4>
              <div class="sub-filters-group-wrapper"
                   v-for="(filtersGroup, key) in filters.creative"
                   :key="key">
                <div class="sub-filters"
                     :key="index"
                     v-for="(filter, index) in filtersGroup">
                  <h5 class="sub-filter-name">{{AllFiltersConfig[filter.key].name}}</h5>
                  <automate-rule-input 
                    v-if="filter.automateRule"
                    @valueChanged="(value) => autoRuleInputChange(filter.key, 'creative', value)"
                    :rangeTypeList="filter.rangeTypeList" 
                    :value="filter.value"
                  />
                  <template v-else>
                    <byted-cascader
                            transfer
                            v-if="AllFiltersConfig[filter.key].type !== rangeFilterType"
                            size="sm"
                            :options="AllFiltersConfig[filter.key].options"
                            v-model="AllFiltersConfig[filter.key].selected"
                            :placeholder="$bp_t('请选择', 'common.please_choose')"
                            :multiple="AllFiltersConfig[filter.key].multiple"
                            collapse-tags
                            @change="handleFilterChange(AllFiltersConfig[filter.key])"></byted-cascader>
                    <!--<range-select v-if="filter.type === rangeFilterType"-->
                                  <!--button-type="primary"-->
                                  <!--@confirm="handleFilterChange(filter)"-->
                                  <!--v-model="AllFiltersConfig[filter.key].selected"></range-select>-->
                  </template>
                </div>
              </div>
            </div>
            <div class="sub-filters-group" v-if="isSearchAdv">
              <h4 class="sub-filters-group-title"
                  id="keyword-anchor">{{ $bp_t('关键词', 'common.keyword') }}</h4>
              <div
                class="sub-filters-group-wrapper"
                v-for="(filtersGroup, key) in filters.keyword"
                :key="key"
              >
                <div
                  class="sub-filters"
                  :key="index"
                  v-for="(filter, index) in filtersGroup"
                >
                  <h5 class="sub-filter-name">{{AllFiltersConfig[filter.key].name}}</h5>
                  <automate-rule-input 
                    v-if="filter.automateRule"
                    @valueChanged="(value) => autoRuleInputChange(filter.key, 'keyword', value)"
                    :rangeTypeList="filter.rangeTypeList" 
                    :value="filter.value"
                  />
                  <template v-else>
                    <byted-cascader
                      transfer
                      v-if="AllFiltersConfig[filter.key].type !== rangeFilterType"
                      size="sm"
                      :options="AllFiltersConfig[filter.key].options"
                      v-model="AllFiltersConfig[filter.key].selected"
                      :placeholder="$bp_t('请选择', 'common.please_choose')"
                      :multiple="AllFiltersConfig[filter.key].multiple"
                      collapse-tags
                      @change="handleFilterChange(AllFiltersConfig[filter.key])"
                    ></byted-cascader>
                  </template>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 关键词搜索框 -->
      <div v-if="searchTypeIsKeyword" class="type-search-wrapper-autocomplete">
        <byted-select size="sm" v-model="searchAll.searchType">
          <byted-option :value="searchTypeObj.value"
                        v-for="(searchTypeObj, searchType) in PromotionTypes"
                        :key="searchType">
            {{searchTypeObj.text}}
          </byted-option>
        </byted-select>
        <byted-auto-complete
          size="sm"
          :placeholder="placeholder"
          v-model="searchAll.searchTerm"
          @keyup.enter.native="onSearchInputKeyDown"
          @search="handleAutoCompleteSearch"
          @select="handleAutoCompleteSelect"
          :data-source="autoCompelteDataSource"
        >
          <template slot="dataSource" slot-scope="{item}">
            <div
              v-if="item.value"
              style="font-size: 12px">
              {{ item.text }}
              <span style="color: #2F88FF">{{ item.value }}</span>
            </div>
          </template>
          <template slot="append">
            <byted-button size="sm"
                          @click="onClickSearchIcon">
              <byted-icon name="search"/>
            </byted-button>
          </template>
        </byted-auto-complete>
      </div>
      <!--组、计划、创意搜索框-->
      <byted-input
        v-else
        class="type-search-wrapper ad-m-b-xs ad-m-l-xs ad-m-r-xs"
        size="sm"
        :placeholder="placeholder"
        v-model="searchAll.searchTerm"
        @keyup.enter="onSearchInputKeyDown">
        <template slot="prepend">
          <byted-select size="sm" v-model="searchAll.searchType">
            <byted-option :value="searchTypeObj.value"
                          v-for="(searchTypeObj, searchType) in PromotionTypes"
                          :key="searchType">
              {{searchTypeObj.text}}
            </byted-option>
          </byted-select>
        </template>
        <template slot="append">
          <byted-button size="sm"
                        @click="onClickSearchIcon">
            <byted-icon name="search"/>
          </byted-button>
        </template>
      </byted-input>

      <!--全局筛选项-->
      <div class="filter-box ad-m-b-xs ad-m-r-xs"
           v-for="(typeSearchBox, index) in typeSearchBoxes"
           :key="index">
        <div class="search-type">{{ typeSearchBoxesText(typeSearchBox) }}</div>
        <div class="search-term txt-cut"
              :title="typeSearchBox.searchTerm">
          {{typeSearchBox.searchTerm}}
        </div>
        <byted-icon name="close-circle"
                    class="ad-m-l-xs"
                    color="#999"
                    @click="onClickClearSearchBox(index, typeSearchBox)"></byted-icon>
      </div>

      <div class="filter-box-with-cascader ad-m-b-xs ad-m-r-xs"
           :class="{multiple: filter.multiple, 'disabled-filter-box': autoRuleDisabled(filter)}"
           v-if="filter.automateRule || filter.selected.length !== 0"
           v-for="(filter, index) in filtersSearchBoxes"
           :key="index">
        <span class="search-type">
          {{AllFiltersConfig[filter.key].name}}：
        </span>
        <div class="search-term">
          <automate-rule-input
            filterSearchBox
            v-if="filter.automateRule"
            @valueChanged="(value) => autoRuleInputChange(filter.key, filter.parentType, value)"
            :rangeTypeList="filter.rangeTypeList" 
            :value="filter.value"
            autoWidth
          />
          <template v-else>
            <byted-cascader
                  transfer
                  v-if="AllFiltersConfig[filter.key].type !== rangeFilterType"
                  size="sm"
                  :options="AllFiltersConfig[filter.key].options"
                  v-model="AllFiltersConfig[filter.key].selected"
                  :placeholder="$bp_t('请选择', 'common.please_choose')"
                  :multiple="AllFiltersConfig[filter.key].multiple"
                  collapse-tags
                  @change="handleFilterChange(AllFiltersConfig[filter.key])"></byted-cascader>
          </template>
          <!--<range-select v-if="filter.type === rangeFilterType"-->
                        <!--button-type="primary"-->
                        <!--@confirm="handleFilterChange(filter)"-->
                        <!--v-model="AllFiltersConfig[filter.key].selected"></range-select>-->
        </div>
        <byted-icon 
          name="close-circle"
          style="z-index: 7"
          class="ad-m-l-xs not-opacity"
          color="#999"
          @click="onClickClearFilterBox(index)"
        >
        </byted-icon>
        <div v-if="autoRuleDisabled(filter) && filter.disabledText" class="disabled-children">
          <byted-popover
            placement="top"
            trigger="hover"
            width="284px"
            transfer
          >
            <div slot="body">{{ filter.disabledText }}</div>
            <div slot="reference" style="color: transparent">fakeText</div>
          </byted-popover>
        </div>
      </div>

      <div class="clear-all-filters-btn ad-m-l-xs ad-m-b-xs"
           v-show="showClearAllFiltersBtn"
           @click="onClickClearAllFilters">{{ $bp_t('清空', 'common.empty') }}
      </div>

    </div>

    <div class="filter-panel-right-part">
      <byted-date-picker-new
              size="sm"
              v-model="globalDate"
              :not-before="oneYearBefore"
              :not-after="todayDate"
              :rangeSeparator="$bp_t('至', 'common.to')"
              type="date"
              :shortcuts="dataShortcuts"
              @change="onDateRangeConfirm"
              range
              format="YYYY.MM.DD"/>
    </div>
  </div>
</template>
<script>
  import {
    SPLICE_GLOBAL_TYPE_SEARCH,
    DATE_FILTER_CHANGE,
    ADD_GLOBAL_TYPE_SEARCH,
    GLOBAL_FILTERS_PARAMS_CHANGE,
    GLOBAL_FILTERS_PARAMS_REPLACE,
    AUTO_MATE_RULES_PARAM,
    FILTERS_SET
  } from 'Src/pages/promotion/store.js'
  import { PromotionTypes, KeyWordSearchType } from 'Src/pagelets/promotion/promotion-state.js'
  import { filtersNav, filters, NoLimitVal, AllFiltersConfig, PromotionFilterValue } from './all-filters-options.js'
  import { SearchQueryKey, QueryFilterParamPrefix, DateQueryKey, writeQueryParams, getCurTabName, getCurQuery } from 'Src/pagelets/promotion/common.js'
  import { dayStr } from 'Src/const/state/common'
  import json from 'Src/util/json.js'
  import teaConst from 'Src/const/tea.js'
  import automateRuleInput from './automate-rule-input.vue'
  import BeginnerGuidePopover from 'Src/components/common/beginner-guide-popover.vue'
  import { BytedIconTips } from '@byte-design/vue-icons'
  import Apis from 'Src/const/apis'
  import Tool from 'Src/util/tool'

  // import 'Src/components/directives/click-outside.js' // import at index.vue

  // import rangeSelect from 'Src/components/input/reporter/range-select.vue'
  // 是否有RF的权限:附身登录以及“RF客户白名单”
  const isRFSupported = GLOBAL_VAR.sales === 'true' && Tool.isSupported(GLOBAL_VAR?.adver_func?.show_rf_report)
  const ptKey = 'purchase_type'
  const localPtKey = GLOBAL_VAR.advertiser.id + ptKey

  export default {
    name: 'filter-panel',
    components: {
      // [rangeSelect.name]: rangeSelect
      [automateRuleInput.name]: automateRuleInput,
      BeginnerGuidePopover,
      BytedIconTips
    },
    props: {
      isShowUserGuide: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const curTabName = getCurTabName()
      return {
        dataShortcuts: [
          {
            text: $bp_t('今天', 'common.today'),
            value: dayStr.today,
            onClick: () => {}
          },
          {
            text: $bp_t('昨天', 'common.yesterday'),
            value: dayStr.before_1,
            onClick: () => {}
          },
          {
            text: $bp_t('过去7天', 'common.past_days'),
            value: [dayStr.before_7, dayStr.before_1],
            onClick: () => {}
          },
          {
            text: $bp_t('过去30天', 'common.past_month'),
            value: [dayStr.before_30, dayStr.before_1],
            onClick: () => {}
          },
          {
            text: $bp_t('本周', 'common.this_week'),
            value: [dayStr.week_start, dayStr.week_end],
            onClick: () => {}
          },
          {
            text: $bp_t('上周', 'common.last_week'),
            value: [dayStr.pre_week_start, dayStr.pre_week_end],
            onClick: () => {}
          },
          {
            text: $bp_t('本月', 'common.this_month'),
            value: [dayStr.month_start, dayStr.month_end],
            onClick: () => {}
          },
          {
            text: $bp_t('上月', 'common.last_month'),
            value: [dayStr.pre_month_start, dayStr.pre_month_end],
            onClick: () => {}
          }
        ],
        searchAll: {
          searchType: PromotionTypes[curTabName].value,
          searchTerm: '',
          keywordSearchType: KeyWordSearchType.phrase // phrase默认值 || term 精确匹配
        },
        PromotionTypes,
        showSubFilterPanel: false,
        filterNavPositionOffset: 20,
        filterNavAnchorPostfix: '-anchor',
        filtersNav,
        filters: _.cloneDeep(filters),
        activeFilterNavID: curTabName,
        AllFiltersConfig,
        rangeFilterType: 'range',
        placeholder: $bp_t('请输入名称或ID搜索', 'bp.promotion_please_enter_a_name_or_id_to_search'),
        autoCompelteDataSource: [],
        isRf: isRFSupported
      }
    },
    watch: {
      'searchAll.searchType': {
        immediate: true,
        handler: function (value) {
          if (value === PromotionTypes?.keyword?.value) {
            this.placeholder = '请输入搜索的关键词'
          } else {
            this.placeholder = $bp_t('请输入名称或ID搜索', 'bp.promotion_please_enter_a_name_or_id_to_search')
          }
        }, 
      },
      '$route.name': function (old, newVal) {
        this.setSearchType()
        this.activeFilterNavID = newVal || getCurTabName()
      },
      curTabName() {
        // tab转换之后自动规则筛选项要使用当前tab下的筛选项，而将其他置灰的去除
        const nextAutoFilter = []
        let showToast = false
        this.filtersSearchBoxes.forEach(item => {
          if(item.automateRule && item.parentType === this.curTabName) {
            nextAutoFilter.push({
              lower: item.value.lower,
              upper: item.value.upper,
              field: item.submitKey
            })
          } else if (item.parentType) {
            if (item.parentType !== this.curTabName) {
              showToast = true
              this.removeOneGlobalParams(item.key)
            } else {
              if (!item.displayOnly) {
                this.setGlobalParams({ [item.key]: this.getFilterParamsValue(item) })
              }

              try {
                const relatedValue = JSON.parse(this.curQuery[item.mappedKey])

                if (item.mappedKey) {
                  this.setGlobalParams({ [item.mappedKey]: relatedValue })
                }
              } catch (error) {}
            }
          }
        })
        showToast && this.$message('计划数据筛选不对广告组、创意、关键词列表生效', 'info')
        this.setGlobalParams({[AUTO_MATE_RULES_PARAM]: nextAutoFilter})
      },
      '$store.state.URLFilters':{
        deep: true,
        handler (newVal) {
          if (newVal && newVal.length) {
            newVal.forEach(filter => {
              if(filter.automateRule) {
                const { parentType, key, value } = filter
                const index = this.filters[parentType]?.normal?.findIndex(item => item.key === key)
                const nextFilter = { ...this.filters[parentType].normal[index], value }
                if(index) {
                  this.$set(this.filters[parentType].normal, index, 
                    _.cloneDeep(nextFilter)
                  )
                }
              }
              if (filter.selected) {
                this.AllFiltersConfig[filter.key].selected = filter.selected
              }
            })
            // 记忆购买类型，rf专属
            window.localStorage.setItem(localPtKey, this.AllFiltersConfig[ptKey].selected[0])
          }
        }
      },
    },
    computed: {
      filtersSearchBoxes: {
        get() {
          return this.$store.state.URLFilters
        },
        set(newValue) {
          this.$store.commit(FILTERS_SET, newValue)
        }
      },
      searchTypeIsKeyword () {
        return this.searchAll.searchType === PromotionTypes?.keyword?.value
      },
      curTabName() {
        return this.$route.name || getCurTabName() // 推广管理四个 tab 改为异步组件后，在初始化时，不能在 router-view 外部依赖 this.$route 去读取当前路由信息，因为 tab 还未挂载时读取到的 this.$route.name 等值是空的
      },
      curQuery() {
        if (Object.keys(this.$route.query) > 0) {
          return this.$route.query
        }
        return getCurQuery()
      },
      oneYearBefore () {
        // 时间筛选年天数都按照365天计算，否则统计服务数据查询不到
        return dayjs().subtract(365, 'd').format('YYYY-MM-DD')
      },
      todayDate () {
        return this.getTodayDateStr()
      },
      globalDate: {
        get () {
          return [this.$store.state.dateFilter.start, this.$store.state.dateFilter.end]
        },
        set () { }
      },
      showClearAllFiltersBtn () {
        return (this.$store.state.typeSearchBoxes.length >= 1 || this.filtersSearchBoxes.length >= 1)
      },
      typeSearchBoxes () {
        return this.$store.state.typeSearchBoxes
      },
      isSearchAdv () {
        return json.catchableParse(GLOBAL_VAR.adv_search_tag)
      },
      storeGlobalFiltersParams() {
        return JSON.parse(this.$store.state.globalFiltersParams)
      }
    },
    mounted () {
      this.$refs.subFiltersContentWrapper
        .addEventListener('scroll', _.debounce(this.listenToFilterPanelScroll, 100))

      this.initDate()
      const defaultKey = 'ad_status'
      if (!this.curQuery[QueryFilterParamPrefix + defaultKey]) {
        const defaultKeySelected = [0]
        this.filtersSearchBoxes.push({
          key: defaultKey,
          selected: defaultKeySelected
        })
        this.AllFiltersConfig[defaultKey].selected.push(PromotionFilterValue.AdStatus.noLimit)
      }
      if (isRFSupported) {
        this.setLastPurchaseType()
      }
    },
    methods: {
      setLastPurchaseType () {
        // 支持RF,没有购买类型就判断上次是否是rf，是则默认选中；有购买类型就按路径上的参数
        const lastSelectedPurchaseType = +window.localStorage.getItem(localPtKey) === PromotionFilterValue.PurchaseType.rf
        if (!this.curQuery[QueryFilterParamPrefix + ptKey] && lastSelectedPurchaseType) {
          const defaultKeySelected = [PromotionFilterValue.PurchaseType.rf]
          this.filtersSearchBoxes.push({
            key: ptKey,
            selected: defaultKeySelected
          })
          this.AllFiltersConfig[ptKey].selected.push(PromotionFilterValue.PurchaseType.rf)
          this.setGlobalParams({[ptKey]: [PromotionFilterValue.PurchaseType.rf]})
        }
      },
      autoRuleInputChange(key, type, value) {
        const index = this.filters[type]?.normal?.findIndex(item => item.key === key)
        const nextFilter = { ...this.filters[type].normal[index], value }
        this.changeAutoRuleExistFilter(key, type, value, _.cloneDeep(nextFilter))
        if(index) {
          this.$set(this.filters[type].normal, index, 
            _.cloneDeep(nextFilter)
          )
        }
      },
      changeAutoRuleExistFilter(key, type, value, nextFilter) {
        const serchBoxIndex = this.filtersSearchBoxes.findIndex(item => item.key === key)
        const nextAutoFilter = _.cloneDeep(this.storeGlobalFiltersParams[AUTO_MATE_RULES_PARAM] || [])
        
        if(serchBoxIndex !== -1) {
          this.$set(this.filtersSearchBoxes, serchBoxIndex, nextFilter)
        } else {
          this.filtersSearchBoxes.push(nextFilter)
        }
        if(nextFilter.parentType === this.curTabName) {
          const nextHasFilter = nextAutoFilter.findIndex(item => item.field === nextFilter.submitKey)
          const submitAutoRule = {
            lower: nextFilter.value.lower,
            upper: nextFilter.value.upper,
            field: nextFilter.submitKey
          }
          if(nextHasFilter !== -1) {
            nextAutoFilter[nextHasFilter] = submitAutoRule
          } else {
            nextAutoFilter.push(submitAutoRule)
          }
          this.setGlobalParams({[AUTO_MATE_RULES_PARAM]: nextAutoFilter})
        }
        const prefixKey = (QueryFilterParamPrefix + key)
        writeQueryParams.call(this, prefixKey, JSON.stringify({ automateRule: true, value }))
      },
      autoRuleDisabled(filter) {
        return filter.parentType && filter.parentType !== this.curTabName
      },
      typeSearchBoxesText (typeSearchBox) {
        if (
          +this.$route?.query?.filter_search_type === PromotionTypes?.keyword?.value // 优先以 url 中的 search_type 为准，因为当刷新页面时，this.searchTypeIsKeyword 会变成当前 tab 对应的 search_type。例如在计划搜索关键词，然后刷新页面，此时search_type会从关键词变为计划
        ) {
          return this.searchAll.keywordSearchType === KeyWordSearchType.term ? `等于关键词：` : `包含关键词：`
        }
        return this.getSearchTypeName(typeSearchBox) + $bp_t('名称或ID包含：', 'bp.promotion_the_name_or_id_contains')
      },
      handleAutoCompleteSearch (value) {
        this.autoCompelteDataSource = [{
          type: KeyWordSearchType.phrase,
          text: '包含',
          value
        }, {
          type: KeyWordSearchType.term,
          text: '等于',
          value
        }]
      },
      handleAutoCompleteSelect (value, item) {
        if (item.type === KeyWordSearchType.term) {
          this.searchAll.keywordSearchType = KeyWordSearchType.term
        } else {
          this.searchAll.keywordSearchType = KeyWordSearchType.phrase
        }
        this.pushNewTypeSearchBox()
      },
      setSearchType () {
        const typeKey = this.curTabName ? this.curTabName : 'ad'
        this.searchAll.searchType = PromotionTypes[typeKey].value
      },
      getSearchTypeName (searchData) {
        let name = ''
        Object.keys(PromotionTypes).some(key => {
          if (PromotionTypes[key].value === parseInt(searchData.typeVal)) {
            name = PromotionTypes[key].text
            return true
          }
        })
        return name
      },
      pushNewTypeSearchBox () {
        if (this.searchAll.searchTerm === '') {
          this.$message($bp_t('请输入搜索关键词', 'bp.promotion_please_enter_search_keywords'), 'error')
          return
        }
        const searchTerm = this.searchAll.searchTerm.toString()

        const { searchType, keywordSearchType } = this.searchAll
        // 更新 store 中的 typeSearchBoxes
        this.$store.commit(ADD_GLOBAL_TYPE_SEARCH, [{
          typeVal: searchType,
          // typeName: typeName,
          searchTerm: searchTerm,
        }])
        // 更新query: searchType 赋值给 filter_search_type，searchTerm 赋值给 filter_search_keyword
        writeQueryParams.call(this, SearchQueryKey.type, searchType)
        writeQueryParams.call(this, SearchQueryKey.keyword, searchTerm)
        // 关键词的搜索时精确还是包含
        writeQueryParams.call(this, SearchQueryKey.queryType, keywordSearchType)
        // 搜索请求埋点
        const teaParam = {
          search_type: searchType,
          keyword: searchTerm
        }
        if (this.searchTypeIsKeyword) {
          teaParam.keywordsearch = this.searchAll.keywordSearchType
        }
        window.teaEvent('promotion_search_request', teaParam)
        // 更新searchType、searchTerm 到 store 中的 globalFiltersParams 
        this.setGlobalParams({
          search_type: searchType,
          keyword: searchTerm,
          query_type: keywordSearchType
        })

        this.addFilterTeaEvent(
          'name', 
          { 
            search_type: searchType,
            keyword: searchTerm
          })
      },
      searchStat () {
        this.pushNewTypeSearchBox()
        this.searchAll.searchTerm = ''
      },
      onSearchInputKeyDown () {
        this.searchAll.keywordSearchType = KeyWordSearchType.phrase
        this.searchStat()
      },
      onClickSearchIcon () {
        this.searchAll.keywordSearchType = KeyWordSearchType.phrase
        this.searchStat()
      },
      onClickClearSearchBox (index) {
        this.$router.push({name: this.curTabName}) // 清空router query

        this.$store.commit(SPLICE_GLOBAL_TYPE_SEARCH, index)
        this.removeOneGlobalParams('search_type')
        this.removeOneGlobalParams('keyword')
        this.removeOneGlobalParams('query_type')

        this.deleteFilterTeaEvent('name')
      },
      clearSingleAutoMateRuleFilter(filter) {
        if (filter.automateRule) {
          // 清除filters里保存的值
          const resetValue = {
            ...filter.value,
            lower: '',
            upper: '',
          }
          Object.keys(this.filters).forEach(key => {
            const nav = this.filters[key]
            nav.normal.forEach((item, index) => {
              if (item.key === filter.key) {
                this.$set(this.filters[key].normal, index, { ...filter, value: resetValue })
              }
            })
          })
          // 清除vuex里保存的值，filters里保存的值不一定会出现在vuex中，因为别的tab的筛选项会disabled,所以只会去除vuex当前tab的
          if (this.curTabName === filter.parentType) {
            const nextAutoFilter = _.cloneDeep(this.storeGlobalFiltersParams[AUTO_MATE_RULES_PARAM] || [])
            const nextHasFilter = nextAutoFilter.findIndex(item => item.field === filter.submitKey)
            if(nextHasFilter !== -1) {
              nextAutoFilter.splice(nextHasFilter, 1)
              this.setGlobalParams({[AUTO_MATE_RULES_PARAM]: nextAutoFilter})
            }
          }
        }
      },
      onClickClearFilterBox (index) {
         const filtersSearchBox = this.filtersSearchBoxes[index]
        const key = filtersSearchBox.key
        if (filtersSearchBox.automateRule) {
          this.clearSingleAutoMateRuleFilter(filtersSearchBox)
        } else {
          this.removeOneGlobalParams(key)
          this.AllFiltersConfig[key].selected = []
        }
        // this.filtersSearchBoxes[index].selected = []
        if( this.AllFiltersConfig[key].isMutuallyExclusive) {
           // 互斥筛选清空后选择默认值
          this.AllFiltersConfig[key].selected = this.AllFiltersConfig[key].defaultSelected
        }else{
          this.AllFiltersConfig[key].selected = []
        }
        this.removeQueryParams(QueryFilterParamPrefix + key, key)
        this.deleteFilterTeaEvent('other')
        this.filtersSearchBoxes.splice(index, 1)
      },
      onClickClearAllFilters () {
        // 清空 所有筛选 筛选项
        this.filtersSearchBoxes.forEach(filter => {
          const key = filter.key
          if (filter.type && filter.type === this.rangeFilterType) {
            AllFiltersConfig[key].selected = {st: '', et: '', unit: ''}
          }else if (filter.isMutuallyExclusive){
            // 互斥筛选清空后选择默认值
            AllFiltersConfig[key].selected = AllFiltersConfig[key].defaultSelected
          } else {
            AllFiltersConfig[key].selected = []
          }
        })
        this.filters = _.cloneDeep(filters)
        this.filtersSearchBoxes = []
        this.setGlobalParams({})

        // 清空 关键词搜索 筛选项
        this.$store.commit(ADD_GLOBAL_TYPE_SEARCH, [])

        // 清空 URL query
        this.$router.push({name: this.curTabName})

        this.clearFilterTeaEvent()
      },
      hasAncestorWithClass (el, cls) {
        while (el && !el.classList.contains(cls)) {
          el = el.parentElement
          if (!el || !el.tagName || el.tagName === 'BODY') {
            return false
          }
        }
        return true
      },
      onClickOutsideAllFilters (event) {
        if (this.isShowUserGuide) {
          return
        }

        // 因为ClickOutside后隐藏panel，和 transfer 的cascader menu冲突了，所以做如下额外判断：
        const isClickingTransferCascader = this.hasAncestorWithClass(event.target, 'bui-cascader-menu')
        if (isClickingTransferCascader) {
          return
        }

        this.showSubFilterPanel = false
      },
      getTodayDateStr () {
        return dayStr.today
      },
      onClickAllFiltersBtn () {
        this.showSubFilterPanel = !this.showSubFilterPanel

        if (this.showSubFilterPanel) {
          window.teaEvent('promotion_open_filter', {
            advertiser_id: GLOBAL_VAR.advertiser.id,
            advertiser_name: GLOBAL_VAR.advertiser.name
          })
        }

        if (this.activeFilterNavID) {
          this.$nextTick(() => {
            this.onClickFilterNavItem(this.activeFilterNavID)
          })
        }
      },
      listenToFilterPanelScroll () {
        const wrapperScrollTop = this.$refs.subFiltersContentWrapper.scrollTop

        this.filtersNav.forEach(nav => {
          const curId = nav.id
          const anchorId = `#${curId}${this.filterNavAnchorPostfix}`
          const curNavEl = document.querySelector(anchorId)
          let curNavOffsetTop
          if (curNavEl) {
            curNavOffsetTop = curNavEl.offsetTop
          }

          if ((wrapperScrollTop + this.filterNavPositionOffset) >= curNavOffsetTop) {
            this.activeFilterNavID = curId
          }
        })
      },
      onClickFilterNavItem (targetId) {
        // document.querySelector(`#${targetId}${this.filterNavAnchorPostfix}`)
        //   .scrollIntoView({behavior: 'smooth'})
        // scrollIntoView 会移动整个页面，PM认为有些奇怪，改为 el.scrollTop 吧
        this.$refs.subFiltersContentWrapper.scrollTop = (document.querySelector(`#${targetId}${this.filterNavAnchorPostfix}`).offsetTop - this.filterNavPositionOffset)
        setTimeout(() => {
          this.activeFilterNavID = targetId
        }, 200)
      },
      replaceGlobalParams (newParams) {
        this.$store.commit(GLOBAL_FILTERS_PARAMS_REPLACE, newParams)
      },
      setGlobalParams (newParams) {
        this.$store.commit(GLOBAL_FILTERS_PARAMS_CHANGE, newParams)
      },
      removeOneGlobalParams (filterKey) {
        // 清除一项 globalParams
        const globalParams = this.storeGlobalFiltersParams
        delete globalParams[filterKey]

        // 清除关联的参数
        const relatedKeys = this.AllFiltersConfig[filterKey]?.relatedKeys

        if (Array.isArray(relatedKeys)) {
          relatedKeys.forEach(key => {
            delete globalParams[key]
          })
        }

        this.replaceGlobalParams(globalParams)
      },
      changeExistFilter (filter) {
        const selectedEmptyToDelete = ((filter.selected.length === 0)
          || (filter.selected.st === '' && filter.selected.et === ''))
        const hasAdded = this.filtersSearchBoxes.some(el => el.key === filter.key)

        if (!hasAdded) {
          this.filtersSearchBoxes.push(filter)
        } else {
          if (selectedEmptyToDelete) {
            let curIndex
            this.filtersSearchBoxes.some((el, index) => {
              if (el.key === filter.key) {
                curIndex = index
                return true
              }
            })

            this.filtersSearchBoxes.splice(curIndex, 1)
          } else {
            // 【DONE】【BUG】回显的筛选盒子，不能从 面板 修改。
            this.filtersSearchBoxes.some(el => {
              if (el.key === filter.key) {
                el.selected = filter.selected
                return true
              }
            })
          }
        }
      },
      getFilterParamsValue (filter) {
        // const key = filter.key
        const selected = filter.selected
        let value = null
        // let tempParam = {}

        if (filter.type) {
          // 范围筛选值处理：
          // if (filter.type === this.rangeFilterType) {
          //   tempParam[key] = {}
          //   if (selected.st) {
          //     tempParam[key]['lower'] = selected.st
          //   }
          //   if (selected.et) {
          //     tempParam[key]['upper'] = selected.et
          //   }
          // }
        } else {
          let selectedValArr
          if (filter.multiple) {
            //这块加个判断  就是审核建议涉及到级联形式 之前语法拿到的value不正确  涉及建议修改时 [-1,对应的下级value]  不要-1 只要下级value
            if(filter.key === "audit_suggest"){
              selectedValArr = selected.map(arr => arr[1] ? arr[1]:arr[0])
            }else {
              selectedValArr = selected.map(arr => arr[0])
            }
            if (selectedValArr && selectedValArr.length) {
              // tempParam[key] = selectedValArr
              value = selectedValArr
            }
          } else {
            const isNotNoLimitVal = (selected[0] !== NoLimitVal) // 筛选项值为"不限（已删除）"时，该筛选字段值为[]
            if (isNotNoLimitVal) {
              selectedValArr = selected
            } else {
              selectedValArr = []
            }

            if (selectedValArr) {
              // tempParam[key] = selectedValArr
              value = selectedValArr
            }
          }
        }

        return value
      },
      handleFilterChange (filter) {
        // 关键词质量度增加埋点
        if (filter.key === 'quality') {
          window.teaEvent('promotion_index_keyword_score_filter', {})
        }
        this.changeExistFilter(filter)
        const key = filter.key
        const paramValue = this.getFilterParamsValue(filter)

        const prefixKey = (QueryFilterParamPrefix + key)
        if (paramValue) {
          this.setGlobalParams({[key]: paramValue})

          if (filter.selected && filter.selected.length) {
            filter.selected.forEach((val) => {
              window.teaEvent('promotion_level_search', {
                filter_key: filter.key,
                filter_key_value: filter.key + '_' + val
              })
            })
          }

          this.addFilterTeaEvent('other')

          // PM规划筛选项后续可能出现层级多选，为了便于日后层级多选时读写，此处写入的参数值不作处理
          writeQueryParams.call(this, prefixKey, JSON.stringify(filter.selected))
        } else {
          this.removeOneGlobalParams(key)
          this.removeQueryParams(prefixKey, key)
        }

      },
      initDate () {
        const todayDateStr = this.getTodayDateStr()
        this.$store.commit(DATE_FILTER_CHANGE, {
          start: todayDateStr,
          end: todayDateStr
        })
      },
      onDateRangeConfirm (newVal) {
        const [start, end] = newVal
        // 时间范围修改埋点
        window.teaEvent('promotion_date_range_change', {
          referer_path: window.location.pathname + window.location.hash.split('?')[0],
          current_module: 'promotion_list',
          start,
          end
        })
        this.$store.commit(DATE_FILTER_CHANGE, {
          start,
          end
        })

        writeQueryParams.call(this, DateQueryKey.startTime, start)
        writeQueryParams.call(this, DateQueryKey.endTime, end)
      },
      removeQueryParams (key, originKey) {
        let curQuery = JSON.parse(JSON.stringify(this.curQuery))

        if (key) {
          delete curQuery[key]
        }

        // 清除关联的参数
        const relatedKeys = this.AllFiltersConfig[originKey]?.relatedKeys

        if (Array.isArray(relatedKeys)) {
          relatedKeys.forEach(key => {
            delete curQuery[key]
          })
        }

        this.$router.push({
          query: curQuery
        })
      },
      addFilterTeaEvent (type, options = {}) {
        window.promotionTeaEvent(
          'promotion_index_add_filter',
          () => {
            return {
              condition: type,
              ...options
            }
          },
          teaConst.type.event
        )
      },
      deleteFilterTeaEvent (type, options = {}) {
        window.promotionTeaEvent(
          'promotion_index_del_filter',
          () => {
            return {
              condition: type,
              ...options
            }
          },
          teaConst.type.event
        )
      },
      clearFilterTeaEvent () {
        window.promotionTeaEvent(
          'promotion_index_clean_filter',
          () => {
            return {}
          },
          teaConst.type.event
        )
      }
    }
  }
</script>
<style lang="scss">
  @import 'Src/pagelets/promotion/promotion-variable.scss';
  @import 'Src/basic/theme.scss';
  @keyframes open{
    from {transform:rotate(0deg);}
    to {transform:rotate(-180deg);}
  }
  @keyframes close{
    from {transform:rotate(-180deg);}
    to {transform:rotate(0deg);}
  }
  .open_{
    animation: open 0.2s;
    animation-fill-mode:forwards;
  }
  .close_{
    animation-fill-mode:forwards;
    animation: close 0.2s;
  }
  $filter-right-part-width: 200px;
  $filter-right-part-margin: 24px;

  $basic-padding: 24px;
  $filter-height: 30px;
  $basic-border-radius: 4px;

  $small-font-size: 12px;
  $icon-size: 14px;
  .disabled-children {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6;
    cursor: not-allowed;
  }
  .filter-panel {
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.08);
    align-items: flex-start !important;
    font-size: 12px;
    position: relative;
    min-height: 50px;
    padding: 16px 24px;
    /*border-top: 1px solid #E4E9ED;*/
    background: #fff;

    .range-select {
      height: $filter-height;
      line-height: $filter-height;
      border-color: #dadfe3;
      .fake-input {
        width: 100%;
        height: $filter-height;
        line-height: $filter-height;
        padding: 0 8px;
        border-radius: 4px;
        margin: 0;
      }
      .byted-icon {
        fill: #999 !important;
      }
    }

    .all-filters-wrapper {
      .btn-filter-all {
        width: 120px;
        .bui-icon-filter svg, .bui-icon-angle-down svg {
          width: $small-font-size;
          height: $small-font-size;
        }
      }

      $byed-loading-z-index: 996;
      .filter-panel-sub-panel {
        min-width: $page-min-width - $windows-scrollbar-width;
        width: 100vw;
        height: 330px;
        position: absolute;
        z-index: $byed-loading-z-index + 1;
        top: 100%;
        left: -1px;
        background-color: #fff;
        border: 1px solid #ddd;
        display: flex;
        $box-shadow-el-height: 1px;
        &:after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: -1;
          width: 100%;
          height: $box-shadow-el-height;
          box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
        }
      }

      .sub-filters-nav-wrapper {
        position: relative;
        width: 152px;
        height: 100%;
        background-color: #F8F9FA;
        padding: 12px 0;
        .filter-nav-item {
          font-size: 14px;
          cursor: pointer;
          line-height: 32px;
          padding: 0 32px;
          a {
            color: #333;
            display: block;
          }
          &:hover {
            background-color: $color-border-block;
          }
          &.active {
            a {
              text-decoration: none;
              color: #2F88FF;
            }
          }
        }

        .close-sub-filters-btn {
          position: absolute;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
        }

      }

      .sub-filters-content-wrapper {
        overflow: auto;
        flex: 1;
        background-color: #fff;
        padding: 20px 32px;

        .sub-filters-group {
          .sub-filters-group-title {
            font-size: $small-font-size;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #999;
            line-height: 17px;
            margin: 0 0 16px;
          }
        }

        .sub-filters-group-wrapper {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          border-bottom: 1px dashed $color-border-block;
          &:last-child {
            border-bottom: none;
          }
          .sub-filters {
            display: flex;
            align-items: flex-start;
            margin-right: 32px;
            margin-bottom: 24px;
            .sub-filter-name {
              display: flex;
              align-items: center;
              width: 60px;
              height: $filter-height;
              line-height: 20px;
              font-size: $small-font-size;
              font-weight: 400;
              margin: 0 12px 0 0;
            }
            .byted-cascader, .range-select {
              width: 190px;
            }
          }
        }

      }
    }

    .type-search-wrapper {
      .byted-select input {
        font-size: $small-font-size;
        width: 90px;
      }
      .bui-icon-search {
        width: $small-font-size;
        height: $small-font-size;
        margin-top: -1px;
      }
      .bui-input {
        width: 136px;
      }
      .bui-input-group-btn button {
        min-width: auto;
        width: $filter-height;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
      }
    }

    .type-search-wrapper-autocomplete {
      display: flex;
      margin: 0 8px 8px 8px;
      width: 254px;
      .byted-select {
        width: 89px;
        input {
          border-right: none;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }
      .byted-auto-complete {
        width: 165px;
        input {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        }
      }
      .bui-input-group-btn {
        button {
          padding: 4px 7px;
          .bui-icon-search {
            margin-top: -1px;
            width: $small-font-size;
            height: $small-font-size;
          }
        }
      }
    }

    .filter-panel-left-part {
      //max-width: $page-min-width - $filter-right-part-width - $filter-right-part-margin;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: -8px; // 抵消未折行时的底边距

      $filter-box-bg-color: #DFEDFF;
      
      .filter-box, .filter-box-with-cascader {
        min-width: 180px;
        font-size: $small-font-size;
        height: $filter-height;
        line-height: $filter-height;
        background-color: $color-border-block;
        padding: 0 12px;
        border-radius: $basic-border-radius;
        position: relative;
        .byted-icon {
          width: $small-font-size;
          height: $small-font-size;
        }
      }

      .filter-box-with-cascader:hover {
        background: #DADFE3;
      }
      .disabled-filter-box {
        background-color: #FAFAFA !important;
        >* {
          opacity: 0.4 !important;
          background-color: #FAFAFA !important;
        }
        >.not-opacity {
          opacity: 1 !important;
        }
      }
      .disabled-filter-box:hover {
        background-color: $color-border-block;
      }

      .filter-box {
        display: flex;
        align-items: center;
        .search-type {
          color: #999;
        }
        .search-term {
          max-width: 40px; // 4位数字
          color: #333;
          display: inline-block;
          .bui-select-wrapper {
            height: $filter-height;
            padding: 0 12px;
            line-height: $filter-height;
          }
        }
      }

      .filter-box-with-cascader {
        display: flex;
        align-items: center;
        &.multiple {
          .byted-cascader {
            width: 160px;
          }
        }
        .byted-cascader {
          cursor: pointer;
          width: 100px;
          border: none;
          height: $filter-height;
          line-height: $filter-height;
          .bui-select-wrapper {
            min-height: $filter-height;
            padding: 0;
          }
          .bui-select-wrapper-multiple, .bui-input {
            height: $filter-height;
            line-height: $filter-height;
            font-size: $small-font-size;
            cursor: pointer;
            border: none;
            box-shadow: none;
            background: transparent;
            max-height: 100%;
            overflow: hidden;
            padding: 0 $icon-size + 4px 0 0;
          }
          .bui-select-tag {
            font-size: $small-font-size;
            line-height: 22px;
            padding: 0;
            background: transparent;
            border: none;
            .bui-tag-close {
              display: none;
            }
          }
          .bui-selected-label {
            font-size: $small-font-size;
            background: transparent;
          }
          .bui-cascader-icon {
            right: 0;
          }
        }
      }

      .clear-all-filters-btn {
        user-select: none;
        cursor: pointer;
        line-height: $filter-height;
        color: #2F88FF;
      }

      .byted-icon {
        cursor: pointer;
        vertical-align: middle;
      }
    }

    .filter-panel-right-part {
      display: flex;
      flex-direction: column;
      min-width: $filter-right-part-width;
      width: $filter-right-part-width;
      margin-left: $filter-right-part-margin;
    }

    .all-filters-wrapper .sub-filters-content-wrapper .sub-filters-group-wrapper .sub-filters .sub-filter-name{
      align-items: unset;
      margin-top: 6px;
    }
  }

  .beginner-guide-popover {
    .guide-title-box {
      display: flex;
      align-items: center;
      .guide-title-icon {
        margin-right: 4px;
      }
    }
    .guide-pop-text {
      line-height: 20px;
    }
  }

  html {
    &:lang(en) {
      .filter-panel {
        .type-search-wrapper {
          .byted-select input {
            width: 104px;
          }
          .bui-input {
            width: 168px;
          }
        }
      }
    }
  }

  html {
    &:lang(ja) {
      .filter-panel {
        .type-search-wrapper {
          .byted-select input {
            width: 104px;
          }
          .bui-input {
            width: 228px;
          }
        }
      }
    }
  }
</style>
